import React, { useEffect, useRef, useState } from 'react';
import { Drawer, Empty, Spin } from 'antd';
import { useHistory } from "react-router-dom";
import { requestMicrophonePermission } from "components/utils/requestMicrophonePermission";

const Arena = (props) => {
  const history = useHistory();
  const {
    route: { currentLocation: region },
  } = props;
  const token = window.localStorage.getItem("access_token");
  const device_id = window.localStorage.getItem("uuid");
  const language = window.localStorage.getItem("lang");
  const objectRef = useRef(null);
  const [iframeReady, setIframeReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    requestMicrophonePermission().finally(() => {
      if (!cancelled) {
        setIframeReady(true);
      }
    });
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    // Add message event listener to log all messages
    const handleMessage = (event) => {
      // Log all messages for debugging
      //console.log('[Arena] Message received:', event);

      // If we want to specifically handle messages from our object, we can check the source
      if (event && event.data && event.data.type === "godotMessage") {
        // console.log('[Arena] Message from embedded object: ', event.data);
        // console.log('[Arena] object: ', objectRef.current, ',', objectRef.current.contentWindow);
        const payload = event.data && event.data.payload || { action: "", data: null }
        const sendMessage = (message) => {
          if (objectRef.current && objectRef.current.contentWindow) {
            console.log(objectRef.current.contentWindow);
            objectRef.current.contentWindow.postMessage(message, "*");
          }
        }

        switch (payload.action) {
          case "askAuthenToken":
            const msg = {
              action: "postAuthenToken", payload: {
                access_token: token,
                device_id: device_id,
                lang: language,
                region: region,
                env: process.env.REACT_APP_ENV,
                app_version: process.env.npm_package_version
              }
            }
            sendMessage({ data: msg })
            break;
          case "openEVIGarten":
            history.push("/");
            break;
        }
      }
    };

    // Add standard message event listeners
    window.addEventListener('message', handleMessage);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  return (
    <Drawer
      visible={true}
      placement="bottom"
      closable={false}
      height="100%"
      headerStyle={{
        height: 56
      }}
      bodyStyle={{
        padding: 0,
        height: '100%'
      }}
      destroyOnClose
    >
      {token && device_id ? (
        iframeReady ? (
          <iframe
            ref={objectRef}
            title="Arena"
            src={`${process.env.REACT_APP_ARENA_URL}/?accessToken=${token}&deviceID=${device_id}`}
            width="100%"
            height="100%"
            frameBorder="0"
            allow="microphone *; autoplay *; fullscreen *"
            allowFullScreen
            style={{ border: "none", display: "block" }}
          />
        ) : (
          <div style={{ display: "flex", justifyContent: "center", marginTop: 40 }}>
            <Spin />
          </div>
        )
      ) : <Empty style={{ marginTop: 40 }} />}
    </Drawer>
  )
}

export default Arena;
